var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1222 10.0611C20.1222 4.50451 15.6177 0 10.0611 0C4.50451 0 0 4.50451 0 10.0611C0 15.0829 3.6792 19.2452 8.48907 20V12.9694H5.9345V10.0611H8.48907V7.84453C8.48907 5.32295 9.99112 3.93013 12.2893 3.93013C13.3901 3.93013 14.5415 4.12663 14.5415 4.12663V6.60261H13.2728C12.0229 6.60261 11.6332 7.37816 11.6332 8.17382V10.0611H14.4236L13.9775 12.9694H11.6332V20C16.443 19.2452 20.1222 15.0829 20.1222 10.0611Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSignup);
export default __webpack_public_path__ + "static/media/facebookSignup.092b6bf1.svg";
export { ForwardRef as ReactComponent };